import * as React from 'react';

export const useWatchModalBodyHeight = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  show: boolean,
  maxHeight: number,
  fixHeight?: boolean,
) => {
  const [elementHeight, setElementHeight] = React.useState(0);

  React.useEffect(() => {
    const element = ref?.current;
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(() => {
      setElementHeight(element.offsetHeight > maxHeight ? maxHeight : element.offsetHeight);
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [show, maxHeight]);

  if (!show) {
    return 0;
  }

  return fixHeight ? maxHeight : elementHeight;
};
